module.exports = __webpack_public_path__ + "img/vertical_7_2_8004.b4dae1a5.png";